function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
})), /*#__PURE__*/React.createElement("polygon", {
  id: "path-2",
  points: "0 0.344821748 11.0015 0.344821748 11.0015 11 0 11"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-4",
  points: "0.00455 0.332473155 12.003 0.332473155 12.003 13 0.00455 13"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Reseller",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  opacity: 0.6
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-9",
  transform: "translate(-28.000000, -8.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(28.000000, 8.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3",
  transform: "translate(0.000000, 9.963900)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-3",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-2"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.0015,9 L2.7355,9 L5.6485,3.969 L6.1035,5.746 C6.2395,6.283 6.7835,6.605 7.3175,6.469 C7.8555,6.332 8.1775,5.787 8.0405,5.253 C8.0405,5.253 6.9785,1.09 6.9765,1.088 C6.8345,0.555 6.2875,0.236 5.7535,0.379 C5.7505,0.38 1.6105,1.529 1.6105,1.529 C1.0795,1.677 0.7685,2.228 0.9155,2.762 C1.0635,3.293 1.6145,3.604 2.1475,3.457 L3.9195,2.965 L0.1365,9.499 C-0.2505,10.164 0.2315,11 1.0015,11 L10.0015,11 C10.5545,11 11.0015,10.553 11.0015,10 C11.0015,9.447 10.5545,9 10.0015,9",
  id: "Fill-1",
  fill: "#000000",
  mask: "url(#mask-3)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.3199,4.4941 C17.7849,4.3581 17.2399,4.6811 17.1029,5.2171 L16.6479,7.0011 L12.8629,0.4631 C12.5059,-0.1539 11.4899,-0.1539 11.1329,0.4631 L6.6359,8.2541 C6.3589,8.7311 6.5219,9.3441 7.0009,9.6201 C7.4789,9.8981 8.0909,9.7321 8.3669,9.2561 L11.9979,2.9601 L14.9149,7.9971 L13.1489,7.5081 C12.6169,7.3591 12.0659,7.6721 11.9179,8.2041 C11.7689,8.7371 12.0819,9.2881 12.6129,9.4341 C12.6129,9.4341 16.7529,10.5831 16.7559,10.5851 C17.2889,10.7261 17.8379,10.4101 17.9779,9.8761 C17.9799,9.8721 19.0419,5.7101 19.0419,5.7101 C19.1779,5.1771 18.8549,4.6321 18.3199,4.4941",
  id: "Fill-4",
  fill: "#000000"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-8",
  transform: "translate(12.000000, 10.963900)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-5",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-4"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8668,8.499 L7.4298,0.833 C7.1538,0.354 6.5408,0.189 6.0638,0.469 C5.5868,0.745 5.4228,1.357 5.6998,1.835 L9.2668,8 L3.4468,8 L4.7598,6.715 C5.1548,6.328 5.1608,5.695 4.7748,5.301 C4.3878,4.906 3.7548,4.899 3.3608,5.285 L0.2978,8.285 C-0.0932,8.676 -0.0932,9.324 0.2978,9.715 L3.3608,12.715 C3.7548,13.101 4.3878,13.095 4.7748,12.699 C5.1608,12.305 5.1548,11.672 4.7598,11.285 L3.4468,10 L11.0018,10 C11.7708,10 12.2538,9.164 11.8668,8.499",
  id: "Fill-6",
  fill: "#000000",
  mask: "url(#mask-5)"
})))));

function SvgSelector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelector);
export default __webpack_public_path__ + "static/media/selector.126647c7.svg";
export { ForwardRef as ReactComponent };